import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import { message, Space, Table, Spin, Typography } from "antd";
import { exportExcel } from "../../extensions/export-excel";
import "./stock.css"
import { ExportExcelButton, HelpButton, isMobile, PrintButton, menuSize } from "../../extensions/design";
const { Text } = Typography;

const StockRest = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const divRef = useRef(null);
  const [isPrinting, setIsPrinting] = useState(false);

  const getData = () => {
    setLoading(true);
    serverFetch("report/currentstock")
      .then(data => {
        setItems(data.sort((a, b) => a.productName.localeCompare(b.productName)));
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => {
      window.print();
      setIsPrinting(false);
    }, 500);
  };

  const handleExportExcel = () => {
    exportExcel(items, columns, "Текущие остатки.xlsx");
  };

  const columns = [
    { dataIndex: "productId", title: "#", },
    { dataIndex: "productName", title: "Товар", },
    { dataIndex: "productUnit", title: "Единица", },
    { dataIndex: "qty", title: "Количество", minWidth:"85px"},
  ]

  const headerSize =  divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY) : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) || 0;

  return !isMobile ? (<div>
    <div className="sport-form-title"></div>
    <Space style={{marginBottom: 8}}>
      <PrintButton onClick={handlePrint} />
      <ExportExcelButton onClick={handleExportExcel} />
      <HelpButton article="tekuschie-ostatki-dvizhenie-tovarov"/>
    </Space>
    {/* <div className="print-btns-div"></div> */}
      <div ref={divRef} style={{width: tableWidth}}>
        <div className={!isPrinting ? "print-area" : "print-area table-print-fullwidth"} style={{ height: "100%", width: "100%" }}>
          <Table dataSource={items} loading={loading} columns={columns} pagination={false} size="small" rowKey="productId"
          scroll={isPrinting ? undefined : { y: tableHeight }} sticky={!isPrinting}/>
        </div>    
      </div>
  </div>) : loading ? (
      <div className="report-loading">
        <Spin size="large" />
      </div>
    ) : (
    <div style={{ height: window.innerHeight - menuSize}} className="stock-scrollable-list">
      {items.map((item) => (
        <div key={item.productId} className="client-item-sale" style={{backgroundColor:""}}>
          <div className="client-item-body">
            <div className="client-item-line-bold-double">
              <div className="client-item-clip">{item.productName}</div>
              <div className="client-item-clip-right" style={{fontWeight:"normal"}}>#{item.productId}</div>
            </div>
            <span>
              <Text className="client-item-clip">Количество: </Text>
              <Text style={{...(item.qty < 0 ? { color: "red" } : { color: "green" }), fontWeight: "bold" }}> {item.qty} {item.productUnit}</Text>
            </span>
          </div>
        </div>
      ))}
      {(items.length === 0 && !loading) ?
        <div style={{ textAlign: "center", marginTop: "20px", fontSize:"14px" }}>Нет данных
        </div> : <></>}
    </div>
  )
}

export default StockRest;